import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { getLedger, setLedger, useLedger } from "@/app/ledger";
import { usePageCrumbs } from "@/components/shell/breadcrumb";
import { ProformaInvoicesPage } from "@/pages/ProformaInvoicesPage";

/**
 * Trang Red PI (Roary 04/11/2026, mục 9): danh sách Red PI — chính màn danh sách PI, chạy trong sổ Red. Mở trang này là chuyển sang sổ
 * Red (công tắc ở thanh trên đổi theo, dải đỏ nhắc trên mọi trang) để đơn bán, phiếu giao, hoá đơn, sao kê… mở từ đây đều đúng sổ.
 * Nút PI mới của danh sách lập Red PI (ở sổ Red, PI mới luôn là Red). Trang nằm sau cổng "Đang làm" (PREVIEW_FEATURES.redPi).
 */
export function RedPiPage() {
  const { t } = useTranslation();
  const ledger = useLedger();
  const cache = useQueryClient();
  usePageCrumbs([{ label: t("redPi.pageTitle") }]);
  // Chỉ chuyển sang sổ Red MỘT lần lúc mở trang. Chạy lại mỗi khi sổ đổi thì bấm "PI thường" ở trang này sẽ bị đẩy ngược về sổ Red
  // ngay trước khi kịp rời trang (bắt được khi kiểm v1.1.85 trên bản đào tạo).
  useEffect(() => {
    if (getLedger() !== "red") {
      setLedger("red");
      void cache.resetQueries();
    }
  }, [cache]);
  if (ledger !== "red") return null;
  return (
    <>
      <div className="mx-4 mt-4 sm:mx-6">
        <div>
          <h1 className="text-xl font-semibold text-ink">{t("redPi.pageTitle")}</h1>
          <p className="mt-1 max-w-3xl text-sm text-ink-soft">{t("redPi.pageIntro")}</p>
        </div>
      </div>
      <ProformaInvoicesPage />
    </>
  );
}
